<template>
  <section class="panel">
    <slot/>
  </section>
</template>

<style lang="scss" scoped>
.panel {
  background-color: #ffffff;
  padding: 10px 20px;
  box-shadow: 0 1px 5px -3px #000;
}
</style>

<script>
export default {
  name: 'panel'
}
</script>
